import { z } from 'zod';
// ── Form schemas (used by both frontend and backend) ─────────────────────────
export const UpdateProfileSchema = z.object({
    fullName: z
        .string()
        .min(2, 'El nombre debe tener al menos 2 caracteres')
        .max(200, 'El nombre no puede superar 200 caracteres'),
    specialty: z.string().max(100).nullable(),
    licenseNumber: z.string().max(100).nullable(),
});
export const SignInSchema = z.object({
    email: z.string().email('Correo electrónico inválido'),
    password: z.string().min(1, 'La contraseña es requerida'),
});
// ── API response schemas ──────────────────────────────────────────────────────
export const TenantApiSchema = z.object({
    id: z.string().uuid(),
    name: z.string().nullable(),
    type: z.string(),
    plan: z.string(),
    country: z.string(),
    language: z.string(),
    timezone: z.string(),
    createdAt: z.string(),
});
export const UserApiSchema = z.object({
    id: z.string().uuid(),
    externalUid: z.string(),
    tenantId: z.string().uuid(),
    email: z.string().email(),
    fullName: z.string().nullable(),
    role: z.enum(['assistant', 'doctor', 'admin', 'super_admin']),
    specialty: z.string().nullable(),
    licenseNumber: z.string().nullable(),
    isActive: z.boolean(),
    capabilities: z.record(z.enum(['none', 'view', 'manage'])),
    createdAt: z.string(),
});
//# sourceMappingURL=auth.js.map